<template>
  <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-1">
        Ответственный за обьект:
      </h5>
    </b-card-header>

    <b-card-body>

      <h4 class="mb-0">{{data.full_name}}</h4>

      <small class="text-muted">@{{ data.username }}</small>

       <table class="my-1 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Должность</span>
            </th>
            <td class="pb-50">
              {{ data.worker }}
            </td>
          </tr>
        </table>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        :to="{ name: 'users-user-view', params: { id: data.id } }"
      >
        Перейти к профилю
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BBadge, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
  },
}
</script>

<style>

</style>
